import { z } from 'zod';
export const HighRiskVerticalAnalysisSectionSchema = z.object({
    displayName: z.string(),
    status: z.enum([
        'clear',
        'alert'
    ]),
    content: z.string()
}).strict().meta({
    id: 'HighRiskVerticalAnalysisSection'
});
export const HighRiskVerticalAnalysisResultSchema = z.object({
    vertical: z.string(),
    promptName: z.string(),
    verticalDisplayName: z.string(),
    summary: z.string(),
    sections: z.array(HighRiskVerticalAnalysisSectionSchema)
}).strict().meta({
    id: 'HighRiskVerticalAnalysisResult'
});

//# sourceMappingURL=high-risk-analysis.schema.js.map